var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMapsReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.google{fill:url(#google-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36069,
    stopColor: "#5998f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#3c85f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3369cb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "google",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M54.69769,70.37994c5.39594-6.78296,13.51373-18.10339,13.51373-24.81848,0-10.05792-8.1535-18.21143-18.21143-18.21143s-18.21143,8.1535-18.21143,18.21143c0,6.71509,8.1178,18.03552,13.51373,24.81848,2.40778,3.02667,6.98761,3.02667,9.39539,0ZM44.84857,50.76355l.42157-3.58942-2.45087-2.65607c-.70087-.75952-.29993-1.99341.71356-2.19598l3.54395-.70819,1.76874-3.15167c.5058-.90131,1.80316-.90131,2.30896,0l1.76874,3.15167,3.54395.70819c1.01349.20258,1.41443,1.43646.71356,2.19598l-2.45087,2.65607.42157,3.58942c.12054,1.02643-.92902,1.789-1.86804,1.35718l-3.28339-1.51013-3.28339,1.51013c-.93903.43182-1.98859-.33075-1.86804-1.35718Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMapsReviewsScraper);
export default __webpack_public_path__ + "static/media/google-maps-reviews-scraper.84e61a352862bb9b63eee30657889097.svg";
export { ForwardRef as ReactComponent };